import { render } from "./BackgroundComponent.vue?vue&type=template&id=2097c6f2"
import script from "./BackgroundComponent.vue?vue&type=script&lang=js"
export * from "./BackgroundComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__